<template>
  <div>
    <div class="flex justify-between items-center pb-5">
      <button class="btn btn-purple back" @click.prevent="goBack()">
        <i class="material-icons align-middle text-4xl">arrow_back_ios</i>
      </button>
    </div>

    <p class="mb-8">
      Now we ask you to share with CHI how you would definite your ideal Au
      Pair. Once again, we encourage you to answer all questions.
    </p>
    <ChiCard className="p-12">
      <form>
        <!-- What type of Au Pair would suit your family ? -->
        <fieldset>
          <legend class="font-semibold text-2xl">
            What type of Au Pair would suit your family the most?
          </legend>

          <div class="mt-3">
            <div
              v-for="(suitability, index) in characteristics.suitability"
              :key="index"
              class="flex flex-col lg:flex-row items-center justify-start mb-8"
            >
              <p-check
                v-model="suitability.value"
                class="ml-5 lg:ml-0 p-switch p-fill w-full mb-3 lg:mb-0 lg:w-1/3"
                color="success"
              >
                <span class="font-medium">{{ suitability.key }}</span>
              </p-check>
              <p class="w-full lg:w-2/3 text-sm">
                {{ suitability.description }}
              </p>
            </div>
          </div>
        </fieldset>

        <!-- Languages -->
        <fieldset>
          <legend class="font-semibold text-2xl">
            Languages
          </legend>

          <div class="mt-3">
            <label>Desired English Proficiency</label>
            <div
              class="flex flex-col lg:flex-row lg:items-center justify-between flex-wrap mt-4"
            >
              <p-radio
                v-model="characteristics.englishProficiency"
                class="p-icon p-round mb-5 lg:mb-0"
                value="Intermediate"
                name="desiredEnglishProficiency"
                color="success"
              >
                <i slot="extra" class="icon material-icons">done</i>
                Intermediate
              </p-radio>

              <p-radio
                v-model="characteristics.englishProficiency"
                class="p-icon p-round mb-5 lg:mb-0"
                value="Higher Intermediate"
                name="desiredEnglishProficiency"
                color="success"
              >
                <i slot="extra" class="icon material-icons">done</i>
                Higher Intermediate
              </p-radio>
              <p-radio
                v-model="characteristics.englishProficiency"
                class="p-icon p-round mb-5 lg:mb-0"
                value="Fluent"
                name="desiredEnglishProficiency"
                color="success"
              >
                <i slot="extra" class="icon material-icons">done</i>
                Fluent
              </p-radio>
              <p-radio
                v-model="characteristics.englishProficiency"
                class="p-icon p-round mb-5 lg:mb-0"
                value="Native"
                name="desiredEnglishProficiency"
                color="success"
              >
                <i slot="extra" class="icon material-icons">done</i>
                Native
              </p-radio>
            </div>
          </div>

          <div class="mt-8">
            <label>Other Desired Languages Spoken</label>
            <div class="mt-3">
              <p-check
                v-for="(language, index) in characteristics.languageSpoken"
                :key="index"
                class="text-lg md:text-base p-icon p-smooth tracking-tight w-full md:w-1/5 md:my-3 my-5"
                color="success"
                v-model="language.value"
              >
                <i slot="extra" class="icon material-icons">done</i>
                {{ language.key }}
              </p-check>
            </div>
          </div>
        </fieldset>

        <!-- Age Range -->
        <fieldset>
          <legend class="font-semibold text-2xl">
            Age
          </legend>

          <div class="mt-3">
            <label>Select preffered Au Pair age</label>

            <div class="age-slider flex items-center justify-between">
              <div class="mt-5 mb-5">
                <p>
                  From
                  <strong>{{ characteristics.minAge }}</strong>
                </p>

                <div class="slidecontainer">
                  <input
                    @change="adjustTo"
                    v-model="characteristics.minAge"
                    type="range"
                    min="18"
                    max="27"
                    value="18"
                    class="slider"
                    id="ageFrom"
                  />
                </div>
              </div>

              <div class="mt-5 mb-5">
                <p>
                  Up to
                  <strong>{{ characteristics.maxAge }}</strong>
                </p>
                <div class="slidecontainer">
                  <input
                    @change="adjustFrom"
                    v-model="characteristics.maxAge"
                    type="range"
                    min="18"
                    max="27"
                    value="27"
                    class="slider"
                    id="ageTo"
                  />
                </div>
              </div>
            </div>
          </div>
        </fieldset>

        <!-- Infant Care Required -->
        <fieldset>
          <legend class="font-semibold text-2xl">
            Infant Care Required?
          </legend>

          <div class="mt-3">
            <label
              >Infant Care is required for children under the age of two (2)
              years old.</label
            >
            <div class="flex flex-col lg:flex-row lg:items-left flex-wrap mt-4">
              <p-radio
                v-model="characteristics.infantCare"
                class="p-icon p-round mb-5 lg:mb-0"
                :value="true"
                name="infantCareRequired"
                color="success"
              >
                <i slot="extra" class="icon material-icons">done</i>
                Yes
              </p-radio>

              <p-radio
                v-model="characteristics.infantCare"
                class="p-icon p-round mb-5 lg:mb-0"
                :value="false"
                name="infantCareRequired"
                color="success"
              >
                <i slot="extra" class="icon material-icons">done</i>
                No
              </p-radio>
            </div>
          </div>
        </fieldset>

        <!-- Gender -->
        <fieldset>
          <legend class="font-semibold text-2xl">
            Gender
          </legend>

          <div class="mt-3">
            <label>Preferred Au Pair Gender</label>
            <div class="flex flex-col lg:flex-row lg:items-left flex-wrap mt-4">
              <p-radio
                v-model="characteristics.gender"
                class="p-icon p-round mb-5 lg:mb-0"
                value="Female"
                name="preferredGender"
                color="success"
              >
                <i slot="extra" class="icon material-icons">done</i>
                Female
              </p-radio>

              <p-radio
                v-model="characteristics.gender"
                class="p-icon p-round mb-5 lg:mb-0"
                value="Male"
                name="preferredGender"
                color="success"
              >
                <i slot="extra" class="icon material-icons">done</i>
                Male
              </p-radio>
              <p-radio
                v-model="characteristics.gender"
                class="p-icon p-round mb-5 lg:mb-0"
                value="Any"
                name="preferredGender"
                color="success"
              >
                <i slot="extra" class="icon material-icons">done</i>
                Any
              </p-radio>
            </div>
          </div>
        </fieldset>

        <!-- Nationality -->
        <fieldset>
          <legend class="font-semibold text-2xl">
            Nationality
          </legend>
          <p class="text-sm leading-4">
            CHI only lists countries it currently works with.
          </p>

          <div
            class="mt-3 flex flex-col md:flex-row justify-between items-center"
          >
            <div class="w-full md:mr-3">
              <label for="desirableCountries">Desirable Country(ies)</label>
              <multiselect
                id="desirableCountries"
                v-model="desirableCountries"
                :options="availableCountries"
                :multiple="true"
                label="name"
                track-by="name"
                :close-on-select="false"
                placeholder="Please select"
              ></multiselect>
            </div>
            <div class="w-full mt-5 md:mt-0 md:ml-3">
              <label for="undesirableCountries">Undesirable Country(ies)</label>
              <multiselect
                id="undesirableCountries"
                v-model="undesirableCountries"
                :options="availableCountries"
                :multiple="true"
                label="name"
                track-by="name"
                :close-on-select="false"
                placeholder="Please select"
              ></multiselect>
            </div>
          </div>
        </fieldset>

        <!-- Swimming -->
        <fieldset>
          <legend class="font-semibold text-2xl">
            Swimming
          </legend>

          <div class="mt-3">
            <label>Choose preferred swimming skills</label>
            <div
              class="flex flex-col lg:flex-row lg:items-left justify-between flex-wrap mt-4"
            >
              <p-radio
                v-model="characteristics.swimming"
                class="p-icon p-round mb-5 lg:mb-0"
                value="1"
                name="swimmer"
                color="success"
              >
                <i slot="extra" class="icon material-icons">done</i>
                No skills
              </p-radio>
              <p-radio
                v-model="characteristics.swimming"
                class="p-icon p-round mb-5 lg:mb-0"
                value="2"
                name="swimmer"
                color="success"
              >
                <i slot="extra" class="icon material-icons">done</i>
                Beginner
              </p-radio>
              <p-radio
                v-model="characteristics.swimming"
                class="p-icon p-round mb-5 lg:mb-0"
                value="3"
                name="swimmer"
                color="success"
              >
                <i slot="extra" class="icon material-icons">done</i>
                Intermediate
              </p-radio>
              <p-radio
                v-model="characteristics.swimming"
                class="p-icon p-round mb-5 lg:mb-0"
                value="4"
                name="swimmer"
                color="success"
              >
                <i slot="extra" class="icon material-icons">done</i>
                Advanced
              </p-radio>
            </div>
          </div>

          <div
            v-if="characteristics.swimming && characteristics.swimming !== '1'"
            class="mt-8"
          >
            <label>Does the Au Pair have to swim with the kids?</label>
            <div class="flex flex-col lg:flex-row lg:items-left flex-wrap mt-4">
              <p-radio
                v-model="characteristics.swimWithKids"
                class="p-icon p-round mb-5 lg:mb-0"
                :value="true"
                name="comfortableSwimmingWithKids"
                color="success"
              >
                <i slot="extra" class="icon material-icons">done</i>
                Yes
              </p-radio>

              <p-radio
                v-model="characteristics.swimWithKids"
                class="p-icon p-round mb-5 lg:mb-0"
                :value="false"
                name="comfortableSwimmingWithKids"
                color="success"
              >
                <i slot="extra" class="icon material-icons">done</i>
                No
              </p-radio>
            </div>
          </div>
        </fieldset>

        <!-- Driving -->
        <fieldset>
          <legend class="font-semibold text-2xl">
            Driving
          </legend>

          <div class="mt-3">
            <label>
              Will the Au Pair be required to drive during the program?
            </label>
            <div class="flex flex-col lg:items-left flex-wrap mt-4">
              <p-radio
                v-model="driver"
                class="p-icon p-round mb-5"
                :value="true"
                name="driver"
                color="success"
              >
                <i slot="extra" class="icon material-icons">done</i>
                Yes
              </p-radio>

              <p-radio
                v-model="driver"
                class="p-icon p-round mb-5"
                value="no"
                name="driver"
                color="success"
              >
                <i slot="extra" class="icon material-icons">done</i>
                No
              </p-radio>
            </div>
          </div>

          <div v-if="driver && driver !== 'no'" class="mt-3">
            <label>
              Desired driving experience
            </label>
            <div class="flex flex-col lg:flex-row lg:items-left flex-wrap mt-4">
              <p-radio
                v-model="characteristics.drivingExperience"
                class="p-icon p-round mb-5"
                value="2"
                name="drivingExperience"
                color="success"
              >
                <i slot="extra" class="icon material-icons">done</i>
                Beginner
              </p-radio>

              <p-radio
                v-model="characteristics.drivingExperience"
                class="p-icon p-round mb-5"
                value="3"
                name="drivingExperience"
                color="success"
              >
                <i slot="extra" class="icon material-icons">done</i>
                Intermediate
              </p-radio>
              <p-radio
                v-model="characteristics.drivingExperience"
                class="p-icon p-round mb-5"
                value="4"
                name="drivingExperience"
                color="success"
              >
                <i slot="extra" class="icon material-icons">done</i>
                Experienced
              </p-radio>
            </div>
          </div>
        </fieldset>

        <!-- Religion -->
        <fieldset>
          <legend class="font-semibold text-2xl">
            Religion
          </legend>

          <div class="mt-3">
            <label>Are you willing to host an Au Pair of another faith?</label>
            <div class="flex flex-col lg:flex-row lg:items-left flex-wrap mt-4">
              <p-radio
                v-model="characteristics.anotherFaith"
                class="p-icon p-round mb-5 lg:mb-0"
                :value="true"
                name="auPairFromAnotherFaith"
                color="success"
              >
                <i slot="extra" class="icon material-icons">done</i>
                Yes
              </p-radio>

              <p-radio
                v-model="characteristics.anotherFaith"
                class="p-icon p-round mb-5 lg:mb-0"
                :value="false"
                name="auPairFromAnotherFaith"
                color="success"
              >
                <i slot="extra" class="icon material-icons">done</i>
                No
              </p-radio>
            </div>
          </div>

          <div class="mt-5">
            <label
              >Do you require the Au Pair to attend religious activities with
              the family?</label
            >
            <div class="flex flex-col lg:flex-row lg:items-left flex-wrap mt-4">
              <p-radio
                v-model="characteristics.requiredReligionAttendance"
                class="p-icon p-round mb-5 lg:mb-0"
                :value="true"
                name="attendReligiousActivities"
                color="success"
              >
                <i slot="extra" class="icon material-icons">done</i>
                Yes
              </p-radio>

              <p-radio
                v-model="characteristics.requiredReligionAttendance"
                class="p-icon p-round mb-5 lg:mb-0"
                :value="false"
                name="attendReligiousActivities"
                color="success"
              >
                <i slot="extra" class="icon material-icons">done</i>
                No
              </p-radio>
            </div>
          </div>
        </fieldset>

        <!-- Smoking -->
        <fieldset>
          <legend class="font-semibold text-2xl">
            Smoking
          </legend>

          <div class="mt-3">
            <label
              >Would you consider hosting an Au Pair who smokes, provided he/she
              abides by your house rules regarding smoking?
            </label>
            <div class="flex flex-col lg:flex-row lg:items-left flex-wrap mt-4">
              <p-radio
                v-model="characteristics.liveWithSmokers"
                class="p-icon p-round mb-5 lg:mb-0"
                :value="true"
                name="smoking"
                color="success"
              >
                <i slot="extra" class="icon material-icons">done</i>
                Yes
              </p-radio>

              <p-radio
                v-model="characteristics.liveWithSmokers"
                class="p-icon p-round mb-5 lg:mb-0"
                :value="false"
                name="smoking"
                color="success"
              >
                <i slot="extra" class="icon material-icons">done</i>
                No
              </p-radio>
            </div>
          </div>
        </fieldset>

        <!-- Alcohol Consumption -->
        <fieldset>
          <legend class="font-semibold text-2xl">
            Alcochol Consumption
          </legend>

          <div class="mt-3">
            <label>
              If 21 years or older, can the Au Pair consume alcoholic beverages
              in the home provided he/she abides by your house rules regarding
              drinking?</label
            >
            <div class="flex flex-col lg:flex-row lg:items-left flex-wrap mt-4">
              <p-radio
                v-model="characteristics.liveWithDrinkers"
                class="p-icon p-round mb-5 lg:mb-0"
                :value="true"
                name="alcocholConsumption"
                color="success"
              >
                <i slot="extra" class="icon material-icons">done</i>
                Yes
              </p-radio>

              <p-radio
                v-model="characteristics.liveWithDrinkers"
                class="p-icon p-round mb-5 lg:mb-0"
                :value="false"
                name="alcocholConsumption"
                color="success"
              >
                <i slot="extra" class="icon material-icons">done</i>
                No
              </p-radio>
            </div>
          </div>
        </fieldset>
      </form>
      <div class="flex mt-12">
        <button
          @click.prevent="submitForm()"
          class="btn btn-purple w-full text-center"
          :disabled="this.loading"
        >
          Find my Ideal Au Pair
        </button>
      </div>
      <progress-bar
        class="progress"
        size="huge"
        :bar-color="`${progress >= 100 ? '#48BB78' : '#553C9A'}  `"
        text-fg-color="#fff"
        bg-color="#CDB9E1"
        text-position="middle"
        :val="progress"
        :text="`${progress >= 100 ? '100' : progress}%`"
      ></progress-bar>
    </ChiCard>
  </div>
</template>

<script>
import ChiCard from "@/components/UI/ChiCard.vue";
import Multiselect from "vue-multiselect";
import ProgressBar from "vue-simple-progress";

export default {
  name: "AuPairCharacteristics",
  components: {
    ChiCard,
    Multiselect,
    ProgressBar,
  },
  props: ["availableCountries", "characteristics"],
  data() {
    return {
      ageTo: 30,
      ageFrom: 18,
      loading: false,
      progress: 0,
      progressValues: {
        suitability: 0,
        languages: 0,
        gender: 0,
        nationality: 0,
        swimming: 0,
        driving: 0,
        religion: 0,
        smoking: 0,
        alcohol: 0,
      },

      driver:
        this.characteristics.drivingExperience !== "no" &&
        this.characteristics.drivingExperience !== null
          ? true
          : this.characteristics.drivingExperience,

      desirableCountries: null,
      undesirableCountries: null,
    };
  },
  watch: {
    characteristics: {
      deep: true,
      handler: function() {
        this.handleProgress();
      },
    },
    driver: {
      deep: true,
      handler: function(val) {
        if (val === "no") {
          this.characteristics.drivingExperience = 1;
        }
        this.handleDrivingProgress(val);
      },
    },
  },
  methods: {
    submitForm() {
      this.loading = true;
      window.localStorage.setItem("compatibilityCTA", "false");
      this.characteristics.desirableCountries = this.desirableCountries.map(
        (item) => item.sevisCode
      );
      this.characteristics.undesirableCountries = this.undesirableCountries.map(
        (item) => item.sevisCode
      );

      this.$emit("saveAuPairCharacteristics");
    },
    calcProgress() {
      const values = Object.values(this.progressValues);
      const progress = values.reduce((acc, val) => {
        acc = acc + val;
        return acc;
      }, 0);

      this.progress = progress;
    },
    handleProgress() {
      const shouldUpdate = this.characteristics.suitability.some(
        (item) => item.value
      );
      shouldUpdate
        ? (this.progressValues.suitability = 30)
        : (this.progressValues.suitability = 0);

      this.characteristics.englishProficiency !== null
        ? (this.progressValues.languages = 10)
        : 0;

      this.characteristics.languageSpoken.some((l) => l.value !== false) !==
      false
        ? (this.progressValues.languages = 10)
        : 0;

      this.characteristics.gender !== null
        ? (this.progressValues.gender = 10)
        : 0;

      this.characteristics.swimming !== null
        ? (this.progressValues.swimming = 10)
        : 0;

      this.characteristics.anotherFaith !== null
        ? (this.progressValues.religion = 10)
        : 0;
      this.characteristics.requiredReligionAttendance !== null
        ? (this.progressValues.religion = 10)
        : 0;
      this.characteristics.liveWithSmokers !== null
        ? (this.progressValues.smoking = 10)
        : 0;
      this.characteristics.liveWithDrinkers !== null
        ? (this.progressValues.alcohol = 10)
        : 0;

      this.calcProgress();
    },

    handleDrivingProgress(val) {
      if (val !== null) {
        this.progressValues.driving = 10;
      } else {
        this.progressValues.driving = 0;
      }
      this.calcProgress();
    },

    adjustFrom() {
      document.querySelector("#ageFrom").setAttribute("max", this.ageTo);
    },
    adjustTo() {
      document.querySelector("#ageTo").setAttribute("min", this.ageFrom);
    },
    goBack() {
      this.$emit("goBack");
    },
  },
  created() {
    this.desirableCountries = this.characteristics.desirableCountries.map(
      (item) => {
        return this.availableCountries.find((ac) => ac.sevisCode === item);
      }
    );
    this.undesirableCountries = this.characteristics.undesirableCountries.map(
      (item) => {
        return this.availableCountries.find((ac) => ac.sevisCode === item);
      }
    );
    this.handleProgress();
    this.handleDrivingProgress(this.driver);
  },
};
</script>

<style scoped lang="scss">
@import url("../../../node_modules/vue-multiselect/dist/vue-multiselect.min.css");

button.back {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  margin-top: 5px;
}

fieldset::after {
  content: "";
  width: 100%;
  height: 2px;
  @apply bg-purple-ap-t03;
  position: relative;
  display: block;
  margin: 20px 0;
}

fieldset:last-child::after {
  display: none;
}

.progress {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100vw;
  z-index: 99999999;
}

input[type="text"] {
  border: 1px solid rgba(0, 0, 0, 0.25);
  font-size: 1rem;
  @apply appearance-none;
  @apply block;
  @apply w-full;
  @apply rounded;
  @apply py-3;
  @apply px-4;
  @apply mb-1;

  &:focus {
    color: #495057;
    background-color: #fff;
    border-color: #80bdff;
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
  }
}

.age-slider > div {
  width: 49%;
}

.slider {
  -webkit-appearance: none;
  width: 100%;
  height: 5px;
  border-radius: 5px;
  background: #d3d3d3;
  outline: none;
  opacity: 0.7;
  -webkit-transition: 0.2s;
  transition: opacity 0.2s;
}

.slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #9a69cb;
  cursor: pointer;
}

.slider::-moz-range-thumb {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #9a69cb;
  cursor: pointer;
}
</style>
